/**
 * Card helper utilities for tarot card operations
 */

/**
 * Get emoji icon for a card suit
 * @param {string} suit - The suit name (Swords, Wands, Cups, Pentacles)
 * @returns {string} - The emoji icon for the suit
 */
export function getSuitEmoji(suit) {
  const suitEmojis = {
    'Swords': '⚔️',
    'Wands': '🪄',
    'Cups': '🏆',
    'Pentacles': '✡️'
  };
  return suitEmojis[suit] || '';
}

/**
 * Sort cards by suit order and number
 * @param {Array} cardList - Array of card objects
 * @returns {Array} - Sorted array of cards
 */
export function sortCardsBySuit(cardList) {
  const suitOrder = {
    'Major': 0,
    'Swords': 1,
    'Wands': 2,
    'Cups': 3,
    'Pentacles': 4
  };
  
  return [...cardList].sort((a, b) => {
    const suitA = a.arcana === 'Major' ? 'Major' : a.suit;
    const suitB = b.arcana === 'Major' ? 'Major' : b.suit;
    const orderA = suitOrder[suitA] || 999;
    const orderB = suitOrder[suitB] || 999;
    
    if (orderA !== orderB) {
      return orderA - orderB;
    }
    
    // Within same suit, sort by number/rank
    return (a.number || 0) - (b.number || 0);
  });
}
